import React, { Component } from 'react'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'
import { dateFormatter, numberFormatter } from "../../../common/formatters";

class WarehousingIssuesListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick(this.props.data.id)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete(this.props.data.id)
    }

    render = () => (
        <tr onClick={this.handleClick} className="row-selectable">
            <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                <td className="w-60 table-buttons">
                    <PermissionsCheck has={[PERMS.UPDATE]}>
                        <button className="far fa-pencil text-gray m-r-xxs" />
                    </PermissionsCheck>
                    <PermissionsCheck has={[PERMS.DELETE]}>
                        <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                    </PermissionsCheck>
                </td>
            </PermissionsCheck>
            <td className="w-100">
                {dateFormatter(this.props.data.date)}
            </td>
            <td className="w-140">
                {this.props.warehouse ? this.props.warehouse.code : ''}
            </td>
            <td className="w-400">
                {this.props.customer ? this.props.customer.name : ''}
            </td>
            <td className="w-140 text-right">
                {numberFormatter(this.props.data.items_count, '0,0')}
            </td>
            <td className="w-140 text-right">
                {numberFormatter(this.props.data.total_price, '0,0.00', this.props.currency ? this.props.currency.iso_code : '')}
            </td>
            <td className="w-max wm-300">
                {this.props.data.note}
            </td>
        </tr>
    )
}

export default WarehousingIssuesListRow
